<template>
  <a-divider></a-divider>

  <a-card style="width: 100%">
    <div v-for="data in json_data_frame">
      <div style="width: 100%">{{ data }}</div>
    </div>
  </a-card>
</template>


<script>
import An from "../../AnimateNumber.vue";
export default {
  components: {
    An,
  },
  props: {
    timestamp: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    json_data_frame: {
      type: Object,
      required: true,
    },
  },
  computed: {},
};
</script>